/* ==========================================================================
   Zapatos Obi 2026 — product-gallery.js
   Carrusel de la galería en móvil/tablet: sincroniza la tira de miniaturas
   ([data-gallery-dots] › [data-gallery-dot]) y el contador "1 / N"
   ([data-gallery-counter]) con el scroll-snap del track ([data-product-gallery]).
   En escritorio la galería es una rejilla y este JS no hace nada visible.
   ========================================================================== */
(function () {
  'use strict';

  var gal = document.querySelector('[data-product-gallery]');
  if (!gal) return;
  var dots = document.querySelectorAll('[data-gallery-dot]');
  var counter = document.querySelector('[data-gallery-counter]');

  function items() {
    return Array.prototype.slice.call(gal.querySelectorAll('.product-gallery__item:not(.product-gallery__item--filler)'));
  }

  function sincronizar() {
    var list = items();
    if (!list.length) return;
    var mejor = 0;
    var min = Infinity;
    for (var i = 0; i < list.length; i++) {
      var d = Math.abs(list[i].offsetLeft - gal.scrollLeft);
      if (d < min) { min = d; mejor = i; }
    }
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-active', j === mejor);
      if (j === mejor) { dots[j].setAttribute('aria-current', 'true'); } else { dots[j].removeAttribute('aria-current'); }
    }
    if (counter) counter.textContent = (mejor + 1) + ' / ' + list.length;
  }

  var t;
  gal.addEventListener('scroll', function () {
    clearTimeout(t);
    t = setTimeout(sincronizar, 80);
  }, { passive: true });

  for (var k = 0; k < dots.length; k++) {
    (function (idx) {
      dots[idx].addEventListener('click', function () {
        var list = items();
        if (list[idx]) gal.scrollTo({ left: list[idx].offsetLeft, behavior: 'smooth' });
      });
    })(k);
  }
})();
